import { Link } from 'react-router';
import { Empty } from '../ui/ui';

export function NotFoundPage() {
  return (
    <Empty title="Esta página no existe" action={<Link to="/">Volver al tablero</Link>}>
      Revisa la dirección o usa el menú lateral.
    </Empty>
  );
}
